<template lang="html">
  <div id="travelover-page">

    <section class="placed-backg banner-section">
    </section>

    <section class="container agent-section">
      <div class="box-top">
        <h2 class="mb-3 title-s1 c-primary">AGENTE AUTORIZADO</h2>

        <p>
          <a class="btn btn-s2 outline-csecondary b-radius" @click="openInfoModal(1)">¿QUÉ ES UN TRAVELOVER?</a>
          <a class="btn btn-s2 outline-csecondary b-radius" @click="openInfoModal(2)">¿QUÉ OFRECEMOS?</a>
          <a class="btn btn-s2 outline-csecondary b-radius" @click="openInfoModal(3)">¿QUIÉNES SOMOS?</a>
          <a class="btn btn-s2 outline-csecondary b-radius" @click="openInfoModal(4)">TIPOS DE TRAVELOVER</a>
        </p>
      </div>

      <div class="box-carousel">
        <h5 class="cursor-pointer subtitle"><a @click="scrollToEl">¡ÚNETE <span>AHORA!</span></a></h5>

        <swiper class="swiper" :options="agentsOptions">
          <swiper-slide v-for="(b, btInx) in 3" :key="'btInx-'+btInx">
            <div class="box-image">
              <img src="public/images/pages/travelover/banner-2-1.jpg">
            </div>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

        <p class="text-center mt-3 txt-c-primary">
          CONSULTA NUESTROS <router-link class="f-w-700 txt-c-primary" target="_blank" to="/terminos-y-condiciones">TÉRMINOS Y CONDICIONES</router-link>
        </p>
      </div>
    </section>

    <section class="container benefits-section">
      <div class="box-title">
        <h2 class="title-s1">BENEFICIOS</h2>
      </div>

      <div class="box-earnings">
        <h4><span class="f-w-700">GANANCIAS DE MÁS DE</span><br />$20,000 PESOS</h4>
      </div>

      <div class="box-information">
        <div class="col-lg-7 placed-backg  col-image"></div>

        <div class="col-lg-5 col-text">
          <div class="box">
            <h4 class="title">
              TU AGENCIA DE VIAJES DE MANERA "ONLINE"
            </h4>

            <div class="info">
              <p>
                <strong>Nuestro modelo de negocio es ideal para ti que te gusta todo lo relacionado con ventas por internet</strong>
                y tienes un nicho de mercado que viaja.<br />
                Iníciate con todas las herramientas necesarias para desarrollar tu agencia de viajes virtual. Un negocio de fácil operación y que puedes realizar en tu tiempo libre desde la comodidad de tu casa.
              </p>
            </div>

            <p class="mt-3 mt-sm-4 text-center text-lg-left">
              <a class="btn btn-s2 bg-white" @click="$refs['modal-contact'].show();">ME INTERESA AFILIARME</a>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="container how-works-section">
      <div class="box">
        <h2 class="mb-4 main-title">¿CÓMO FUNCIONA?</h2>

        <p class="text-center">
          <img class="img-fluid" src="public/images/pages/travelover/how-works.svg">
        </p>

        <div class="row box-academy">
          <div class="col-lg-5 col-logo">
            <img src="public/images/pages/travelover/viajare-academia.svg" alt="">
          </div>

          <div class="col-lg-7 col-info">
            <h4 class="text-1">
              CON ACADEMIA VIAJARE DESARROLLARÁS LAS <strong>HERRAMIENTAS</strong> NECESARIAS PARA COMENZAR <strong>TU</strong>
            </h4>
            <h3 class="text-2">CAMINO AL ÉXITO.</h3>

            <h5 class="mt-4 subtitle">¿ESTÁS LISTO?</h5>

            <p class="mt-3">
              <a class="btn btn-s1 bg-c-primary" @click="$refs['modal-contact'].show();">MÁS INFORMACIÓN</a>
            </p>

            <div class="box-opts">
              <div class="box-icon">
                <img src="public/images/pages/travelover/ic-graduation.png">
              </div>

              <h5 class="mt-4 subtitle"><i class="fa-solid fa-check"></i> <span>Preparación</span></h5>
              <ul>
                <li>Portafolio de Productos</li>
                <li>Destinos Clave</li>
                <li>Características de los Clientes</li>
                <li>Tendencias del Mercado</li>
                <li>Uso de Herramientas y Recursos</li>
                <li>Capacitación en Ventas</li>
                <li>Atención al Cliente</li>
                <li>Conocimiento del Producto</li>
                <li>Marketing Digital</li>
                <li>Uso de Tecnología</li>
                <li>Tendencias del Mercado</li>
                <li>Desarrollo de Habilidades Blandas</li>
                <li>Crisis y Manejo de Situaciones</li>
                <li>Networking y Colaboración</li>
                <li>Certificaciones</li>
              </ul>
            </div>

            <div class="box-opts">
              <div class="box-icon">
                <img src="public/images/pages/travelover/ic-marketing.png">
              </div>

              <h5 class="mt-4 subtitle"><i class="fa-solid fa-check"></i> <span>Marketing</span></h5>
              <ul>
                <li>Campañas de Publicidad</li>
                <li>Material de Marketing</li>
                <li>Entrenamiento en Marketing Digital</li>
                <li>Acceso a una Plataforma de Reservas</li>
                <li>Promociones y Descuentos Exclusivos</li>
                <li>Soporte en Redes Sociales</li>
                <li>Email Marketing</li>
                <li>Apoyo en eventos y Ferias</li>
                <li>Programas de Fidelización</li>
                <li>Investigación de Mercado</li>
                <li>Acceso a Webinars y Capacitación</li>
              </ul>
            </div>

            <div class="box-opts">
              <div class="box-icon">
                <img src="public/images/pages/travelover/ic-platforms.png">
              </div>

              <h5 class="mt-4 subtitle"><i class="fa-solid fa-check"></i> <span>Plataformas</span></h5>
              <ul>
                <li>Introducción a la Plataformas de Reservas</li>
                <li>
                  Soft de control- Oficina Virtual.
                  <ol>
                    <li>Sistema De Gestión de Reservas</li>
                    <li>Sistema de Gestión de Clientes</li>
                  </ol>
                </li>
                <li>Canales de Venta</li>
                <li>Soporte Técnico y Recursos</li>
              </ul>
            </div>

            <div class="box-opts">
              <div class="box-icon">
                <img src="public/images/pages/travelover/ic-commission.png">
              </div>

              <h5 class="mt-4 subtitle"><i class="fa-solid fa-check"></i> <span>Comisiones & Descuentos</span></h5>
              <ul>
                <li>Introducción al Sistema de Comisiones</li>
                <li>Estructura de Comisiones</li>
                <li>Descuentos y Ofertas Especiales</li>
                <li>Incentivos por venta</li>
                <li>Viajes de familiarización</li>
                <li>Espacios Co working</li>
                <li>Precios especiales para tus viajes</li>
                <li>Sin limites Geográficos</li>
                <li>Libertad de horarios</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="box-ready">
          <h5 class="subtitle">¿AÚN NO ESTÁS LISTO?</h5>
          <h6>CON VIAJARE TENDRÁS UN<br />MUNDO DE OPORTUNIDADES.</h6>

          <p>
            <a class="btn btn-s2 bg-white b-radius" @click="scrollToEl">¡ESTAMOS PARA AYUDARTE!</a>
          </p>
        </div>
      </div>
    </section>

    <section class="container about-faqs-section">
      <h2 class="title-s1 c-primary">SÉ TU PROPIA JEFA Y LOGRA INDEPENDENCIA ECONÓMICA</h2>

      <div class="row">
        <div class="col-lg-6 col-info">
          <div class="box-intro">
            <div class="box-title">
              <h4>
                CONOCE CÓMO <strong>VIAJARE HA CAMBIADO LA VIDA DE NUESTROS DISTRIBUIDORES</strong>
              </h4>
            </div>

            <div class="d-block mb-3">
              <img class="img-fluid" src="public/images/pages/travelover/icons-1.svg">
            </div>

            <div class="d-block">
              <p class="p-check">
                <i class="fa-solid fa-check icon"></i> CAPACITACION CONSTANTE Y ACTUALIZACIONES
              </p>
              <p class="p-check">
                <i class="fa-solid fa-check icon"></i> CAPACITACIONES ONLINE
              </p>
              <p class="p-check">
                <i class="fa-solid fa-check icon"></i> DESARROLLA TU NEGOCIO A TU TIEMPO
              </p>
            </div>
          </div>

          <div class="box-faqs">
            <h5 class="mb-1 subtitle">PREGUNTAS FRECUENTES</h5>
            <p class="txt-c-secondary">Aquí las respuestas a las preguntas más comunes sobre Viajare Afiliados</p>

            <div class="faqs">
              <b-card no-body v-for="(qa, qaInx) in faqs" :key="'qaInx-'+qaInx">
                <b-card-header header-tag="header" role="tab">
                  <a class="btn-question" v-b-toggle="'accordion-'+qaInx">{{ qa.q }}</a>
                </b-card-header>
                <b-collapse :id="'accordion-'+qaInx" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p>
                      {{ qa.a }}
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-videos">
          <div class="box-video">
            <video src="public/videos/video-1.mp4" controls poster="public/images/pages/travelover/video-1.jpg">
              Tu navegador no admite el elemento <code>video</code>.
            </video>
          </div>

          <div class="box-video">
            <video src="public/videos/video-2.mp4" controls poster="public/images/pages/travelover/video-2.jpg">
              Tu navegador no admite el elemento <code>video</code>.
            </video>
          </div>

          <div class="box-video">
            <video src="public/videos/video-3.mp4" controls poster="public/images/pages/travelover/video-3.jpg">
              Tu navegador no admite el elemento <code>video</code>.
            </video>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="calculator-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-content px-lg-0">
            <h4 class="text-center title-1">CALCULA CUÁNTO PUEDES GANAR</h4>
            <h5 class="text-center subtitle">COMO AGENTE AUTORIZADO “TRAVELOVER”</h5>

            <h4 class="mt-4 text-center title-1">SI YO VENDO:</h4>

            <div class="box-calculator-form">
              <b-form @submit="onSubmitCalculator">
                <b-form-group>
                  <b-form-input
                    v-model="formCalculator.amount"
                    type="number"
                    placeholder="INGRESA UN MONTO (VENTAS)"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-button type="submit" class="btn btn-s1 bg-c-secondary">CALCULAR MIS INGRESOS</b-button>
              </b-form>
            </div>

            <div class="box-guarantee">
              <h4 class="text-center title-1">MIS GANANCIAS SERÍAN DE:</h4>

              <div class="guarantee">
                <div class="text-right txt">$</div>
                <div class="total">1,560.00</div>
                <div class="text-left txt">MXN</div>
              </div>

              <h6 class="sub">¡QUIERO SER UN TRAVELOVER!</h6>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="container contact-section" id="contact-el">
      <h2 class="title-s1 c-primary">CONTÁCTANOS</h2>

      <div class="box-form">
        <b-form @submit="onSubmitContact">
          <b-form-group class="custom-form-group-s2">
            <b-form-input
              v-model="formContact.name"
              type="text"
              placeholder="NOMBRE Y APELLIDO"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="custom-form-group-s2">
            <b-form-input
              v-model="formContact.email"
              type="email"
              placeholder="CORREO ELECTRÓNICO"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="custom-form-group-s2">
            <b-form-input
              v-model="formContact.phone"
              type="text"
              placeholder="TELÉFONO"
              minlength="10"
              maxlength="10"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="custom-form-group-s2">
            <b-form-textarea
              v-model="formContact.msg"
              placeholder="ASUNTO"
              rows="4"
              max-rows="4"
            ></b-form-textarea>
          </b-form-group>

          <div class="row pt-1 pt-lg-3">
            <div class="col-lg-9 col-text">
              <p>
                RELLENA EL FORMULARIO CON TUS DATOS, DÍNOS LO QUE NECESITAS
                Y TE RESPONDEREMOS LO ANTES POSIBLE. OLVÍDATE DE
                TUS INQUIETUDES Y COMIENZA ESTA TRAVESÍA.
              </p>
            </div>

            <div class="col-lg-3 col-button mt-3 mt-sm-2 mt-lg-0">
              <b-button type="submit" class="btn btn-s1 bg-c-primary">ENVIAR FORMULARIO</b-button>
            </div>
          </div>
        </b-form>
      </div>
    </section>

    <!-- Modal info de agente -->
    <b-modal modal-class="modal-info-s1" ref="modal-info" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-12 col-info">
          <!-- (1) ¿Qué es un Travelover? -->
          <div v-if="modalInfo == 1">
            <!-- <h6 class="t-1">TRAVELOVER</h6> -->
            <h4 class="text-center modal-title">¿Qué es un Travelover?</h4>
            <!-- <h5 class="subtitle">xx</h5> -->

            <div class="box-description">
              <h5 class="f-w-600">Emprende con nosotros</h5>
              <p>
                Un Travelover de Viajare es una persona altamente capacitada en destinos turísticos que, sin estar sujeto a limitaciones temporales, busca maximizar su desarrollo profesional mientras genera ingresos adicionales. Al unirse a una empresa consolidada como Viajare, tienes la oportunidad de formar parte de un equipo que se dedica a generar experiencias inolvidables a los clientes y a que busca transformar la experiencia de viaje de miles de personas.
              </p>
              <p class="mt-3">
                Con 12 años en el mercado, hemos respaldo a más de 200 personas que buscan una oportundiad de negocio. Gracias a la colaboración de nuestros Travelovers, estamos comprometidos a llegar a cada rincón de México, proporcionando a nuestros clientes experiencias únicas y memorables. Al ser parte de Viajare, no solo ampliarás tus horizontes profesionales, sino que también contribuirá al enriquecimiento del turismo en nuestro país.
              </p>

              <br />
              <h6 class="f-w-600">¿Qué ofrecemos?</h6>
              <p>
                Ofrecemos una plataforma integral para emprendedores apasionados por los viajes. Esto incluye capacitación personalizada, herramientas de marketing, soporte en ventas y acceso a una comunidad de Travelovers. Nuestro objetivo es equiparte con todo lo necesario para que puedas diseñar y vender experiencias de viaje únicas y memorables.
              </p>

              <br />
              <h6 class="f-w-600">Tipos de Travelover</h6>
              <p>
                Existen diferentes tipos de Travelovers, adaptados a tus intereses y habilidades.
              </p>
              <br />
              <p>
                Puedes ser un Travelover Pro, enfocándote en la comercialización de paquetes turísticos; un Travelover Business, que crea itinerarios únicos, que utiliza estrategias en línea para atraer clientes. Cada tipo ofrece oportunidades únicas para crecer y tener éxito en el mundo del turismo.
              </p>
            </div>

            <!-- <div class="box-buttons">
              <a class="btn btn-s1 bg-c-primary" href="tel:">CONTACTAR</a>
            </div> -->
          </div>
          <!--  -->

          <!-- (2) ¿Qué ofrecemos? -->
          <div v-if="modalInfo == 2">
            <h4 class="text-center modal-title">¿Qué ofrecemos?</h4>

            <div class="box-description">
              <p>
                Ofrecemos una plataforma integral para emprendedores apasionados por los viajes. Esto incluye capacitación personalizada, herramientas de marketing, soporte en ventas y acceso a una comunidad de Travelovers. Nuestro objetivo es equiparte con todo lo necesario para que puedas diseñar y vender experiencias de viaje únicas y memorables.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- (3) ¿Quiénes somos? -->
          <div v-if="modalInfo == 3">
            <h4 class="text-center modal-title">¿Quiénes somos?</h4>

            <div class="box-description">
              <p>
                Somos un equipo de profesionales del turismo y el emprendimiento dedicados a empoderar a personas como tú para que se conviertan en Travelovers. Con años 12 años experiencia en el sector, nuestra misión es fomentar la pasión por los viajes mientras ayudamos a construir negocios sostenibles y exitosos.
              </p>
            </div>
          </div>
          <!--  -->

          <!-- (4) Tipos de Travelover -->
          <div v-if="modalInfo == 4">
            <h4 class="text-center modal-title">Tipos de Travelover</h4>

            <div class="box-description">
              <p>
                Existen diferentes tipos de Travelovers, adaptados a tus intereses y habilidades.
              </p>
              <br />
              <p>
                Puedes ser un Travelover Pro, enfocándote en la comercialización de paquetes turísticos; un Travelover Business, que crea itinerarios únicos, que utiliza estrategias en línea para atraer clientes. Cada tipo ofrece oportunidades únicas para crecer y tener éxito en el mundo del turismo.
              </p>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </b-modal>
    <!--  -->

    <!-- Modal contact -->
    <b-modal modal-class="modal-info-s1" ref="modal-contact" size="lg" title="" centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div class="row no-gutters">
        <div class="col-12 col-info">
          <h2 class="mb-3 text-center modal-title">Formulario de contacto</h2>

          <b-form @submit="onSubmitContact">
            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formContact.name"
                type="text"
                placeholder="NOMBRE Y APELLIDO"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formContact.email"
                type="email"
                placeholder="CORREO ELECTRÓNICO"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-input
                v-model="formContact.phone"
                type="text"
                placeholder="TELÉFONO"
                minlength="10"
                maxlength="10"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="custom-form-group-s2">
              <b-form-textarea
                v-model="formContact.msg"
                placeholder="MENSAJE"
                rows="3"
                max-rows="3"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-right">
              <b-button type="submit" class="btn btn-s1 btn-lg outline-c-white-2">ENVIAR INFO</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </b-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      modalInfo: null,

      faqs: [
        { q: '¿Cómo integrarme como Travelover? ¿Qué requisitos solicitan?',
          a: `Para emprender como Travelover, debes llenar un formulario de inscripción en nuestro sitio web. Los requisitos incluyen ser mayor de edad, tener pasión por los viajes y un interés en el emprendimiento. También es útil contar con habilidades de comunicación y ventas.`
        },
        { q: '¿Qué beneficios tengo al emprender con Viajare?',
          a: `Emprender con Viajare te brinda la oportunidad de trabajar en el sector turístico, acceso a capacitación continua, una comunidad de apoyo y la posibilidad de generar ingresos pasivos. Además, podrás disfrutar de descuentos en viajes y experiencias exclusivas.`
        },
        { q: '¿Qué cantidad debo invertir para tener mi negocio como Travelover?',
          a: `La única inversión necesaria es de $30,000. Esta cantidad cubre tu capacitación y todas las herramientas necesarias para iniciar tu negocio, incluyendo soporte de ventas, marketing y diseño de viajes. Es una inversión integral que te preparará para tener éxito en el sector turístico.`
        },
        { q: '¿Formas de pago?',
          a: `Aceptamos diversas formas de pago, incluyendo tarjetas de crédito, transferencias bancarias y plataformas digitales. Puedes elegir la opción que mejor se adapte a ti durante el proceso de inscripción.`
        },
        { q: '¿Forma en la que generarás ingresos?',
          a: `Generarás ingresos a través de comisiones por ventas de paquetes de viaje, promociones y referidos. Cuanto más crezca tu red y más viajes vendas, mayores serán tus ingresos.`
        },
        { q: '¿Qué documentos necesito?',
          a: `Necesitarás presentar tu identificación oficial, un comprobante de domicilio y una constancia de situación fiscal. Estos documentos son esenciales para formalizar tu registro y asegurarte de que estás preparado para iniciar tu camino como Travelover. Además, pueden ser requeridos para acceder a ciertos beneficios y promociones dentro de la comunidad.`
        },
      ],

      formCalculator: {
        amount: null,
      },

      formContact: {
        name: null,
        email: null,
        phone: null,
        msg: null,
      },

      // == Carousel options ==
      agentsOptions: {
        loop: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
      // == ==
    }
  },

  methods: {
    openInfoModal(val) {
      this.modalInfo = val;
      this.$refs['modal-info'].show();
    },

    scrollToEl() {
      var scrollDiv = document.getElementById("contact-el").offsetTop;
      window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
    },

    onSubmitCalculator(event) {
      event.preventDefault();
    },

    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-center',
        appendToast: true
      })
    },

    onSubmitContact(event) {
      event.preventDefault();

      var params = this.formContact;
      var apiURL = tools.url("/api/contact");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        // alert(response.data.response);

        for (let prop in this.formContact) {
          this.formContact[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
  },

  mounted() {

  },
}
</script>
